<template>
    <div class="china">
        <NavBar :white="true" />
        <ChinaContent />
    </div>
</template>

<script>
    import NavBar from "../../components/NavBar";
    import ChinaContent from "../../components/location/ChinaContent";
    import Configuration from "../../utils/configuration";

    export default {
        name: 'GlobalChina',
        components: {
            NavBar,
            ChinaContent,
        },
        metaInfo: {
          title: '中国の日系広告代理店、オンラインマーケティングはオロ',
          meta: [
            {
              property: 'description',
              content: 'Wechat,Baidoといった中国独自のプラットフォームを利用したデジタルマーケティングを通じて企業のマーケティング支援を行っています。',
              vmid: 'description'
            },
            {
              property: 'og:title',
              content: '中国の日系広告代理店、オンラインマーケティングはオロ',
              vmid: 'og:title'
            },
            {
              property: 'og:url',
              content: 'https://www.oro.com/global/location/china/',
              vmid: 'og:url'
            },
            {
              property: 'og:type',
              content: Configuration.site.meta.og_type,
              vmid: 'og:type'
            },
            {
              property: 'og:site_name',
              content: Configuration.site.meta.og_site_name,
              vmid: 'og:site_name'
            }
          ]
        }
    }
</script>

<style lang="scss">
    .china {
        padding-top: 160px;
    }
</style>
